const value = {
    successTitle: 'Успешно (от 70 до 100%)',
    successSubtitle: 'Все ответы верные',
    neutralTitle: 'Нейтрально (от 50 до 69%)',
    neutralSubtitle: 'Более 50% ответов верные, но есть хотя бы одна ошибка',
    failedTitle: 'Провал (от 0 до 49%)',
    failedSubtitle: 'Более 50% ответов неверные',
  };

export default value;
